import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { AccountService } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { WebviewService } from 'src/app/services/platform/webview.service';

@Component({
  standalone: true,
  selector: 'app-account-register-credentials-step',
  templateUrl: './register-credentials-step.component.html',
  styleUrls: ['./register-credentials-step.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatCheckbox, ModalOptionPanelComponent]
})
export class RegisterCredentialsStepComponent {
  @Input() formGroup: FormGroup | null = null;
  @Input() existingEmailMsg: string | null = null;
  @Input() preiOS13WebView: boolean = false;
  @Input() androidWebView: boolean = false;

  @Output() openPrivacyPolicy = new EventEmitter<void>();
  @Output() openTermsOfUse = new EventEmitter<void>();
  @Output() openEUDataActPolicy = new EventEmitter<void>();

  showPassword = false;
  showPasswordConfirmation = false;

  constructor(
    public accountService: AccountService,
    public languageService: LanguageService,
    public settingsService: SettingsService,
    public webviewService: WebviewService
  ) {
    // This step shows the Google and Apple buttons, so their SDKs are needed now (not on every page).
    this.accountService.prepareSocialSignIn();
  }

  get registerEmail() { return this.formGroup!.get('registerEmail')!; }
  get registerPassword() { return this.formGroup!.get('registerPassword')!; }
  get registerPasswordConfirmation() { return this.formGroup!.get('registerPasswordConfirmation')!; }
  get registerPasswordsMatch() { return this.formGroup?.hasError('notSame'); }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  togglePasswordConfirmation(): void {
    this.showPasswordConfirmation = !this.showPasswordConfirmation;
  }
}
